var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M76.3752 23.625L27.4585 72.5417C25.6252 74.375 22.5418 74.125 21.0418 71.9584C15.8752 64.4167 12.8335 55.5 12.8335 46.3334V28.0417C12.8335 24.625 15.4168 20.75 18.5835 19.4584L41.7919 9.95837C47.0419 7.79171 52.8752 7.79171 58.1252 9.95837L74.9586 16.8333C77.7502 17.9583 78.4586 21.5417 76.3752 23.625Z",
    fill: "#8EB4C3",
    fillOpacity: 0.309804
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2913 29.3339C82.9997 27.0422 87.1247 29.0005 87.1247 32.5422V46.3338C87.1247 66.7088 72.333 85.7921 52.1247 91.3755C50.7497 91.7505 49.2497 91.7505 47.833 91.3755C41.9163 89.7088 36.4163 86.9171 31.708 83.2505C29.708 81.7088 29.4997 78.7921 31.2497 77.0005C40.3331 67.7088 66.9163 40.6256 80.2913 29.3339Z",
    fill: "#8EB4C3",
    fillOpacity: 0.309804
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.8d9fe3ab2dc6f21f69dd84256f77e701.svg";
export { ForwardRef as ReactComponent };